var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-bg-1"},[_c('div',{staticClass:"loading-component-v1"},[_c('div',{staticClass:"holder"},[_c('div',{staticClass:"preloader"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])])])
}]

export { render, staticRenderFns }